import L_HTML5 from "../../assets/img/skills/html-5.svg";
import L_CSS3 from "../../assets/img/skills/css3.svg";
import L_SASS from "../../assets/img/skills/sass-1.svg";
import L_ANTD from "../../assets/img/skills/antd.jpg";
import L_BOOTSTRAP from "../../assets/img/skills/bootstrap-4.svg";
import L_REACT from "../../assets/img/skills/react.svg";
import L_NEXT from "../../assets/img/skills/nextjs.svg";
import L_GATSBY from "../../assets/img/skills/gatsby.png";
import L_REDUX from "../../assets/img/skills/redux.svg";
import L_VUE from "../../assets/img/skills/vue.svg";
import L_REACT_ROUTER from "../../assets/img/skills/react-router.svg";
import L_REACT_BOOTSTRAP from "../../assets/img/skills/react-bootstrap.svg";
import L_MATERIALUI from "../../assets/img/skills/material-ui-1.svg";
import L_GIT from "../../assets/img/skills/git-icon.svg";
import L_SVN from "../../assets/img/skills/svn.jpg";
import L_SOURCE_TREE from "../../assets/img/skills/sourcetree.svg";
import L_EMOTION from "../../assets/img/skills/emotion2.webp";
import L_LODASH from "../../assets/img/skills/lodash.svg";
import L_RXJS from "../../assets/img/skills/rxjs.svg";
import L_MOMENT from "../../assets/img/skills/momentjs.svg";
import L_CHART from "../../assets/img/skills/chartjs.svg";
import L_JAVASCRIPT from "../../assets/img/skills/javascript.svg";
import L_TYPESCRIPT from "../../assets/img/skills/typescript.svg";
import L_ANGULAR from "../../assets/img/skills/angular.svg";
import L_EMBER from "../../assets/img/skills/ember.svg";
import L_JEST from "../../assets/img/skills/jest.svg";
import L_CYPRESS from "../../assets/img/skills/cypress.svg";
import L_MOCHA from "../../assets/img/skills/mocha.svg";
import L_CHAI from "../../assets/img/skills/chai.png";
import L_AZURE from "../../assets/img/skills/azure.jpg";
import L_GITLAB from "../../assets/img/skills/gitlab.svg";

export const skills = {
  languages: [
    {
      link: "https://www.javascript.com/",
      imgAltText: "JavaScript",
      imgSrc: L_JAVASCRIPT,
      skillName: "JavaScript",
    },
    {
      link: "https://www.typescriptlang.org/",
      imgAltText: "TypeScript",
      imgSrc: L_TYPESCRIPT,
      skillName: "TypeScript",
    },
    {
      link: "https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5",
      imgAltText: "HTML 5",
      imgSrc: L_HTML5,
      skillName: "HTML5",
    },
    {
      link: "https://developer.mozilla.org/en-US/docs/Archive/CSS3",
      imgAltText: "CSS 3",
      imgSrc: L_CSS3,
      skillName: "CSS3",
    },
    {
      link: "https://sass-lang.com/",
      imgAltText: "Sass",
      imgSrc: L_SASS,
      skillName: "Sass",
    }
  ],
  webComponents: [
    {
      link: "https://ant.design/",
      imgAltText: "AntD",
      imgSrc: L_ANTD,
      skillName: "AntD",
    },
    {
      link: "https://material-ui.com/",
      imgAltText: "Material-UI",
      imgSrc: L_MATERIALUI,
      skillName: "Material-UI",
    },
    {
      link: "https://getbootstrap.com/",
      imgAltText: "Bootstrap",
      imgSrc: L_BOOTSTRAP,
      skillName: "Bootstrap",
    },
    {
      link: "https://react-bootstrap.github.io/",
      imgAltText: "React Bootstrap",
      imgSrc: L_REACT_BOOTSTRAP,
      skillName: "React Bootstrap",
    }
  ],
  libraries: [
    {
      link: "https://github.com/ReactiveX/rxjs",
      imgAltText: "RxJs",
      imgSrc: L_RXJS,
      skillName: "RxJs",
    },
    {
      link: "https://lodash.com/",
      imgAltText: "Lodash",
      imgSrc: L_LODASH,
      skillName: "Lodash",
    },
    {
      link: "https://emotion.sh/",
      imgAltText: "Emotion Js",
      imgSrc: L_EMOTION,
      skillName: "Emotion Js",
    },
    {
      link: "https://momentjs.com/",
      imgAltText: "Moment Js",
      imgSrc: L_MOMENT,
      skillName: "Moment Js",
    },
    {
      link: "https://www.chartjs.org/",
      imgAltText: "Chart Js",
      imgSrc: L_CHART,
      skillName: "Chart Js",
    },
    {
      link: "https://reacttraining.com/react-router/",
      imgAltText: "React Router",
      imgSrc: L_REACT_ROUTER,
      skillName: "React Router",
    },
  ],
  frameworks: [
    {
      link: "https://reactjs.org/",
      imgAltText: "React JS",
      imgSrc: L_REACT,
      skillName: "React JS",
    },
    {
      link: "https://nextjs.org/",
      imgAltText: "Next JS",
      imgSrc: L_NEXT,
      skillName: "Next JS",
    },
    {
      link: "https://www.gatsbyjs.com/",
      imgAltText: "Gatsby JS",
      imgSrc: L_GATSBY,
      skillName: "Gatsby JS",
    },
    {
      link: "https://angular.io/",
      imgAltText: "Angular",
      imgSrc: L_ANGULAR,
      skillName: "Angular",
    },
    {
      link: "https://emberjs.com/",
      imgAltText: "Ember",
      imgSrc: L_EMBER,
      skillName: "Ember",
    },
    {
      link: "https://redux.js.org/",
      imgAltText: "Redux",
      imgSrc: L_REDUX,
      skillName: "Redux",
    },
    {
      link: "https://vuejs.org/",
      imgAltText: "Vue",
      imgSrc: L_VUE,
      skillName: "Vue",
    }
  ],
  versionControl: [
    {
      link: "https://git-scm.com/",
      imgAltText: "GIT",
      imgSrc: L_GIT,
      skillName: "GIT",
    },
    {
      link: "https://www.sourcetreeapp.com/",
      imgAltText: "SourceTree",
      imgSrc: L_SOURCE_TREE,
      skillName: "SourceTree",
    },
    {
      link: "https://subversion.apache.org/",
      imgAltText: "SVN",
      imgSrc: L_SVN,
      skillName: "SVN",
    },
  ],
  testing: [
    {
      link: "https://jestjs.io/",
      imgAltText: "Jest",
      imgSrc: L_JEST,
      skillName: "Jest",
    },
    {
      link: "https://testing-library.com/docs/react-testing-library",
      imgAltText: "React Testing Library",
      imgSrc: "data:image/png;base64,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",
      skillName: "React Testing Library",
    },
    {
      link: "https://www.cypress.io/",
      imgAltText: "Cypress",
      imgSrc: L_CYPRESS,
      skillName: "Cypress",
    },
    {
      link: "https://mochajs.org/",
      imgAltText: "Mocha",
      imgSrc: L_MOCHA,
      skillName: "Mocha",
    },
    {
      link: "https://www.chaijs.com/",
      imgAltText: "Chai",
      imgSrc: L_CHAI,
      skillName: "Chai",
    },
  ],
  devops: [
    {
      link: "https://azure.microsoft.com/en-in/services/devops/",
      imgAltText: "Azure Devops",
      imgSrc: L_AZURE,
      skillName: "Azure Devops",
    },
    {
      link: "https://gitlab.com/",
      imgAltText: "Gitlab",
      imgSrc: L_GITLAB,
      skillName: "Gitlab",
    },
    {
      link: "https://www.jenkins.io/",
      imgAltText: "Jenkins",
      imgSrc: "data:image/png;base64,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",
      skillName: "Jenkins",
    },
  ]
};
